import React from 'react'
import { motion } from "framer-motion";
import Footers from "./Footer";
import Navbar from "./Navbar";

const pageVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0, transition: { duration: 1 } },
};

const MiscellaneousWork = () => {
  return (
    <>
      <motion.div initial="hidden" animate="visible" variants={pageVariants} className="page-wraper" style={{background:'#fff'}}>
      <Navbar />
      <div className="page-content">
        <div
          className="wt-bnr-inr overlay-wraper bg-parallax bg-top-center"
          data-stellar-background-ratio="0.5"
          style={{
            backgroundImage: "url(assets/pic/mission.webp)",
          }}
        >
          <div className="overlay-main bg-black opacity-07"></div>
          <div className="container">
            <div className="wt-bnr-inr-entry">
              <div className="banner-title-outer">
                <div className="banner-title-name">
                  <h2 className="text-white">Miscellaneous work</h2>
                </div>
              </div>
              <div>
                <ul className="wt-breadcrumb breadcrumb-style-2">
                  <li>
                    <a href="/">Home</a>
                  </li>
                  <li>Miscellaneous work</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <motion.div
          className="section-full p-t80 p-b80 overflow-hide"
          style={{ background: "#fff" }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1.2 }}
        >
          <div className="container">
            <div className="section-content">
              <div className="row">
                <motion.div className="col-lg-6 col-md-12" initial={{ x: -50, opacity: 0 }} animate={{ x: 0, opacity: 1 }} transition={{ duration: 1 }}>
                  <div className="arc-home-about-left">
                    <div className="arc-home-left-content" style={{ background: "#fff" }}>
                      <h4 style={{ color: "#B19777",marginBottom:'0px' }}>GET TO KNOW</h4>
                      <h3 className="m-t0"  style={{ color: "#000" ,marginBottom:'0px',fontSize:'17px'}}>Miscellaneous work</h3>
                      <p
                        style={{
                          color: "#7c7c7c",
                          fontSize: "14px",
                          lineHeight: "30px",
                             marginBottom:'0px'
                        }}
                      >
                  Beyond kitchens and bedrooms, we take pride in creating custom furniture and storage solutions that elevate everyday living. From elegant dressing rooms and spacious walk‑in wardrobes to functional study tables, shoe cabinets, beds, and side tables — every piece is designed with precision, crafted from premium materials, and tailored to your lifestyle.
                      </p>
                        <h3 className="m-t0"  style={{ color: "#000" ,marginBottom:'0px',fontSize:'17px'}}>Manufacturing Unit</h3>
                                <p
                        style={{
                          color: "#7c7c7c",
                          fontSize: "14px",
                          lineHeight: "30px",
                          marginBottom:'0px'
                        }}
                      >
Our own state‑of‑the‑art facility, equipped with advanced CNC technology, precision cutting and edging machines, and premium materials. Every panel is cut with exact accuracy, edges are finished seamlessly, and surfaces are crafted to perfection — ensuring durability, flawless detail, and interiors built to the highest standards.
                      </p>
                    </div>
                  </div>
                </motion.div>

                <motion.div className="col-lg-6 col-md-12" initial={{ x: 50, opacity: 0 }} animate={{ x: 0, opacity: 1 }} transition={{ duration: 1 }}>
                  <div className="arc-home-about-right portfolio-wrap">
                    <div className="row">
                      <div className="col-md-12 col-sm-12 masonry-item">
                        <div className="wt-media m-b20 img-reflection">
                          <img src="/assets/pic/mi2.jpg" alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </motion.div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
      <Footers />
      <button className="scroltop">
        <span className="fa fa-angle-up relative" id="btn-vibrate"></span>
      </button>
    </motion.div>
    </>
  )
}

export default MiscellaneousWork
